export const limits = {
  INSIDE_SUBSIDIARY_COUNT: 10,
  OUTSIDE_SUBSIDIARY_COUNT: 10
};

export const MAX_TRADE_LICENSE_NUMBER = 12;

export const initialEntitiesInUAE = [
  {
    companyName: "",
    emirate: "",
    tradeLicenseNo: "",
    tradeLicenseIssueDate: "",
    tradeLicenseExpiryDate: "",
    natureOfBusiness: ""
  }
];

export const initialEntitiesOutsideUAE = [{ companyName: "", country: "", natureOfBusiness: "" }];
export const MAX_COMPANY_NAME_LENGTH = 80;
export const MAX_TRADE_LICENSE_LENGTH = 20;
